var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#005A8B","strokeLinecap":"square","strokeWidth":"2.16"},React.createElement("path",{"d":"M2.44 2.44l13.12 13.12M2.44 15.56L15.56 2.44"})));
}

Close.defaultProps = {"viewBox":"0 0 18 18"};

module.exports = Close;

Close.default = Close;
